import { instance } from "../instance";
import { IAxiosError } from "../interfaces";
import { getError } from "../utils";
import { PATH } from "../../shared/constants";
import { TicketFontCatalogEntry } from "../../shared/interfaces/ticket-font";

export const listTicketFontsRequest = async (): Promise<TicketFontCatalogEntry[]> => {
  try {
    const response = await instance.get<TicketFontCatalogEntry[]>(
      `${PATH.API}/${PATH.TICKET_FONT}`,
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
